import KmAvgFilter from "./KmAvgFilter"

export default  KmAvgFilter;
